/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type DeleteJobLinkedItemModal_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobLinkedItemsTable_jobLinkedItemEdges$ref: FragmentReference;
declare export opaque type JobLinkedItemsTable_jobLinkedItemEdges$fragmentType: JobLinkedItemsTable_jobLinkedItemEdges$ref;
export type JobLinkedItemsTable_jobLinkedItemEdges = $ReadOnlyArray<{|
  +usageQty: ?number,
  +node: {|
    +id: string,
    +itemNumber: string,
    +name: string,
    +partNumber: ?string,
    +description: ?string,
    +category: ?{|
      +id: string,
      +name: string,
    |},
    +quantityUOM: {|
      +id: string,
      +symbol: string,
    |},
    +$fragmentRefs: DeleteJobLinkedItemModal_item$ref,
  |},
  +$refType: JobLinkedItemsTable_jobLinkedItemEdges$ref,
|}>;
export type JobLinkedItemsTable_jobLinkedItemEdges$data = JobLinkedItemsTable_jobLinkedItemEdges;
export type JobLinkedItemsTable_jobLinkedItemEdges$key = {
  +$data?: JobLinkedItemsTable_jobLinkedItemEdges$data,
  +$fragmentRefs: JobLinkedItemsTable_jobLinkedItemEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "JobLinkedItemsTable_jobLinkedItemEdges",
  "type": "JobLinkedItemEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "usageQty",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "itemNumber",
          "args": null,
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "partNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "category",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemCategory",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "quantityUOM",
          "storageKey": null,
          "args": null,
          "concreteType": "UOM",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "symbol",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "DeleteJobLinkedItemModal_item",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '1d9ffea1738415372e3a12444f5b2c5a';
module.exports = node;
